/* eslint-disable */

const INITIAL_STATE = {
  myTest: false,
};

const testReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'TEST_TOGGLE':

      return { ...state, myTest: !state.myTest };

    default:
      return state
  }
}

export default testReducer



// WEBPACK FOOTER //
// ./src/reducers/testReducer.js